const Logo = ({ className = "", size = "default" }: { className?: string; size?: "default" | "lg" | "sm" | "xs" }) => {
  const sizeClasses = {
    lg: "text-3xl",
    default: "text-2xl",
    sm: "text-base",
    xs: "text-sm",
  };

  return (
    <span
      aria-label="Giftou"
      role="img"
      className={`font-logo leading-none text-foreground ${sizeClasses[size]} ${className}`}
    >
      Giftou
    </span>
  );
};

export default Logo;
